import fetch from 'node-fetch'
import servicesUtils from './servicesUtils'

const API_URL = process.env.VUE_APP_API_URL

export const authServices = {

  async signIn(username, password) {
    try {
      const url = `${API_URL}/signIn?t=` + (new Date()).getTime().toString();
      const res = await fetch(url, {
        method: 'POST',
        body: JSON.stringify({
          username: username,
          password: password
        }),
        headers: {
          'Content-Type': 'application/json'
        }
      })

      const data = servicesUtils.checkStatus(res)

      return servicesUtils.parseJSON(data)
    } catch (e) {
      console.log(e)
    }
  },

  async validateAuthState() {
    try {
      const url = `${API_URL}/validateAuthState?t=` + (new Date()).getTime().toString();
      const res = await fetch(url)

      const data = servicesUtils.checkStatus(res)

      return servicesUtils.parseJSON(data)
    } catch (e) {
      console.log(e)
    }
  },

  async signOut() {
    try {
      const url = `${API_URL}/signOut?t=` + (new Date()).getTime().toString();
      const res = await fetch(url)

      return servicesUtils.checkStatus(res)
    } catch (e) {
      console.log(e)
    }
  }
}